import { React, useContext, useEffect, useState ,useMemo} from 'react'
import InvestorProfileHighlights from './InvestorProfileHighlight'
import AllInvestorFunds from './InvestorAllFunds'
import InvestorNewsActivity from './InvestorNewsActivity'
import ComparePopUp from '../../../Pages/ComparePopUp'
import Constants from '../../../Constants'
import axios from 'axios'
import useModule from '../../../hooks/useModule'
import { useParams, useSearchParams, useLocation, NavLink } from 'react-router-dom'
import { Tooltip } from 'antd'
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa'
import { UserContext } from '../../../Contexts/UserContext'
import { TableDataContext } from '../../../Contexts/TableDataContext'
import Tab from '../../shared/Tab'
import RandomLogo from '../../RandomLogo'
import CompanyLogo from '../../CompanyLogo'
import AlertPopUp from '../../DetailPage/AlertPopUp'
import AddNotePopover from '../../shared/AddNotePopover'
import PENotesPopup from '../../NotesPopup/PENotesPopup'
import SendDealPopUp from '../../SendDealPopUp'
import { reInvestorProfileUrl, exportPdf} from '../../../Config/config';
import { routeNames } from '../../../routeSegments';
import XLSPopup from "../../DetailPage/DownloadXLS";
import PdfDownloader from "../../shared/PdfDownloader";
import ReadMoreReadLess from '../../shared/ReadMoreReadLess';
import { debounce, delay } from 'lodash';
import { useInView } from 'react-intersection-observer';
import { DataFoundContext } from '../../../Contexts/DataFoundContext'
import { PeFilterContext } from '../../../Contexts/PeFilterContext'
import moment from 'moment'
 
 

const PortfolioDetails = (props ) => { 

    const overview = () => { document.getElementById("profile").scrollIntoView({ behavior: 'smooth' });; }
    const funds = () => { document.getElementById("funds").scrollIntoView({ behavior: 'smooth' });; }
    const news = () => { document.getElementById("news").scrollIntoView({ behavior: 'smooth' }); }

    const [showModal, setShowModal] = useState(false);

    const { getToken, logout, isStudent } = useContext(UserContext);
    const [URLSearchParams, SetURLSearchParams] = useSearchParams({ section: Constants.primaryMasterSubIds.re_investor_investment_id });
    const { primaryMasterId } = useModule();
    const [isLoading, setIsLoading] = useState(true);
    const { reinvestorId } = useParams()
    const location = useLocation() 
    const [profileData, setProfileData] = useState({})
    const [activetabIndex, setActivetabIndex] = useState(1)
    const [skipScroll, setSkipScroll] = useState(false)
    const { newsAndActivityDataFound } = useContext(DataFoundContext);
    const { monthPickerValue, setMonthPickerValue } = useContext(PeFilterContext);

    const [overviewEl, isOverviewVisible, overviewEntry] = useInView({ threshold: 0.5, rootMargin: "60px 0px 0px 0px", skip: skipScroll })
    const [fundingEl, isfundingVisible, fundingEntry] = useInView({ threshold: 0.5, rootMargin: "60px 0px 0px 0px", skip: skipScroll })
    const [newsEl, isnewsVisible, newsEntry] = useInView({ threshold: 0.5, rootMargin: "60px 0px 0px 0px", skip: skipScroll })


    const section = URLSearchParams.get('section');

    /* The above code is a React useEffect hook that makes an API call using axios. It sends a POST
    request to the specified URL with the provided data and headers. It also includes an abort
    controller to cancel the request if needed. */
    useEffect(() => {
        const controller = new AbortController()
        setIsLoading(true);
        axios(reInvestorProfileUrl, {
            method: "POST",
            data: {
                investor_id: reinvestorId,
                type: primaryMasterId
            },
            signal: controller.signal,
            headers: {
                "Content-Type": "application/json",
                "Authorization": getToken()
            },
        })
            .then((response) => {
                setIsLoading(false);
                if (response?.data?.success === true) {
                    console.log("setProfileData", response.data);
                    setProfileData(response.data?.data);
                }
            })
            .catch((error) => {
                setIsLoading(false);
                if (error?.response?.status === Constants.sessionTerminatedStatus) {
                    logout()
                }
                console.log("API not working", error);
            });
        return () => controller.abort()
    }, [getToken, logout, primaryMasterId, reinvestorId])

    /**
     * The function `onTabClick` is used to handle tab clicks and perform different actions based on
     * the active tab.
     * @param active - The `active` parameter is a number that represents the index of the tab that was
     * clicked. It is used to determine which tab should be activated and which function should be
     * called based on the index.
     */
    const onTabClick = (active) => {
        setSkipScroll(true);
        delay(()=>{
            setSkipScroll(false);
        },500)
        if (active === 1) {
            overview()
        } else if (active === 2) {
            funds()
        } else {
            news()
        }
        setActivetabIndex(active);


    }

    /* The above code is defining a function called `setIsActiveOnScroll` using the `useMemo` hook.
    This function uses the `debounce` function to delay the execution of the `setActivetabIndex`
    function by 100 milliseconds. The `setActivetabIndex` function is passed an `index` parameter,
    which is used to set the active tab index. The `useMemo` hook is used to memoize the function so
    that it is only re-computed when its dependencies change. The empty dependency array `[]`
    indicates that the function does not have any dependencies and */
    const setIsActiveOnScroll = useMemo(() => {
        return debounce(index => setActivetabIndex(index), 100)
    }, [])

    /* The above code is using the useEffect hook in React to set the value of the isActiveOnScroll
    state variable based on the visibility of different sections on the page. It checks the values
    of isOverviewVisible, isfundingVisible, and isnewsVisible variables and sets the
    isActiveOnScroll variable accordingly. */
    useEffect(() => {

        if (isOverviewVisible) {
            setIsActiveOnScroll(1);
        } else if (isfundingVisible) {
            setIsActiveOnScroll(2);
        
        } else if (isnewsVisible) {
            setIsActiveOnScroll(3);
        }
    }, [isOverviewVisible, , isfundingVisible, isnewsVisible, setIsActiveOnScroll])


    const category = parseInt(section) === Constants.primaryMasterSubIds.re_investor_investment_id
        ? "re-investments"
        : parseInt(section) === Constants.primaryMasterSubIds.re_investor_exits_id
            ? "re-exits"
            : "re-ipo"


            /**
             * The function `subTypeMasterId` returns a sub category ID based on the value of the
             * `section` parameter.
             * @returns The function `subTypeMasterId` returns the sub category ID based on the value
             * of the `section` parameter.
             */
            const subTypeMasterId =() =>{
       
                if(section == Constants.primaryMasterSubIds.re_investor_investment_id){
                  return Constants.subCategoryIds.re_investor_investment_id
                }
                else if(section == Constants.primaryMasterSubIds.re_investor_exits_id){
                  return Constants.subCategoryIds.re_investor_exits_id
                }
                
                else if(section == Constants.primaryMasterSubIds.re_investor_ipo_id){
                  return Constants.subCategoryIds.re_investor_ipo_id
                }
               
                
              } 

    const { tableInvestorId: invId } = useContext(TableDataContext);

    const currentIndex = invId?.indexOf(Number(reinvestorId));

    document.title = `${profileData?.topProfile?.investor_name ? profileData?.topProfile?.investor_name + " - " : ""}RE Investors - Venture Intelligence`;

    return (
        <>
            <div className="bg-[#FFFFFF] relative">
                <nav className="flex p-1 px-4 lg:px-1 border-b " aria-label="Breadcrumb">
                    <ol role="list" className="flex items-center space-x-1">
                        <li className='flex items-center'>
                            <div className='flex items-center'> 
                              
                                <NavLink state={location.state?.prevPath} to={location.state?.prevPath != null && location.state?.prevPath !=""
                                    ? location.state?.prevPath
                                   
                                        : routeNames.re_investors_re_investments} 
                                        className="ml-2 text-[11pt] lg:text-[12px]  leading-[14px] font-sans_book_body text-[#666666]">
                                        Investors</NavLink>
                            </div>
                        </li>
                        <li className='flex items-center'>
                            <div className="flex items-center">
                                <span className=" text-[12px] text-[#666666] mr-1">/</span>
                                <span className=" text-[11pt] lg:text-[12px] text-[#666666] font-semibold whitespace-nowrap"
                                >{profileData?.topProfile?.investor_name}</span>
                            </div>
                        </li>
                    </ol>
                </nav>
                <div className="px-4 ">
                    <div className=" py-2 mt-4 bg-[#FFFFFF]">
                        <ul >
                            <li className="w-full flex">
                                <div className=" rounded-md">
                                    {
                                        profileData?.topProfile?.icon_path == "default.png" || profileData?.topProfile?.icon_path == "/default.png" || !profileData?.topProfile?.icon_path
                                            ? <RandomLogo name={profileData?.topProfile?.investor_name} page="detail page" />
                                            : <CompanyLogo name={profileData?.topProfile?.investor_name} id={reinvestorId} page="detail page" logo={profileData?.topProfile?.icon_path} />
                                    }
                                </div>

                                <div className="ml-3 flex flex-1 flex-col">
                                    <span className="text-[#333333] text-[24px] font-semibold leading-[29px]"> {profileData?.topProfile?.investor_name} </span>
                                    <span className=" text-[12pt] leading-[16pt] text-[#333333]  lg:text-[14px] lg:leading-[17px] font-sans_roman_body ">{profileData?.topProfile?.firm_type}</span>
                                </div>
                            </li>
                        </ul>
                    </div>
                    {/* <!-- tags--> */}
                    <div className="bg-[#FFFFFF]">
                        {profileData?.topProfile?.sector != null && profileData?.topProfile?.sector !== ""
                            ? <p className=" lg:block text-[#333333] font-sans_book_body text-[11pt] leading-[17pt] lg:leading-[17px] py-2 lg:text-[14px]  mr-3">
                                Sector : {profileData?.topProfile?.sector}
                            </p>
                            : null}
                    </div>
                </div>

            </div>
            <div className='bg-[#EDEDED]'>
                <AllInvestorFunds category={category} InvestorName={profileData?.topProfile?.investor_name} />
            </div>
            {showModal ? (<ComparePopUp onClose={(e) => setShowModal(false)} />) : null}
        </>
    )

}

export default PortfolioDetails